import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import { authAtom } from "../Atoms";

export interface AuthRouteProps { children: React.ReactNode; }

export function AuthRoute( { children }: AuthRouteProps ) {
    const user            = useAtomValue( authAtom );
    const isAuthenticated = user.isAuthenticated;
    const loc             = useLocation();
    if( !isAuthenticated ) {
        //could save original location to redirect atom
        //then when they log in we can redirect them to it
        return <Navigate to="/login" state={{ from: loc }} replace />;
    }
    return <React.Fragment>{children}</React.Fragment>;
}